import * as React from "react";

const ThinArrowRight = (props) => {
  return (
    <svg width="21px" height="70px" viewBox="0 0 21 70">
      <g stroke="none" strokeWidth="1" fill="#000000" fillRule="evenodd">
        <polygon points="0 2.04680851 1.16170213 0 21 34.9531915 1.16170213 70.0638298 0 67.8595745 18.6765957 34.9531915" />
      </g>
    </svg>
  );
};

export default ThinArrowRight;



// WEBPACK FOOTER //
// ./src/components/Icons/ThinArrowRight.jsx